<template>
	<!-- Renderless component -->
</template>

<script setup>
import { inject, onMounted, onBeforeUnmount, watch } from "vue";

const props = defineProps({
	id: { type: String, required: true },
	type: { type: String, required: true },
	tiles: Array,
	url: String,
	data: Object,
});

const map = inject("map");
const registerSource = inject("registerSource");
const unregisterSource = inject("unregisterSource");

const getSourceConfig = () => {
	const config = { type: props.type };
	if (props.tiles !== undefined) config.tiles = props.tiles;
	if (props.url !== undefined) config.url = props.url;
	if (props.data !== undefined) config.data = props.data;
	return config;
};

onMounted(() => {
	registerSource(props.id, getSourceConfig());
});

onBeforeUnmount(() => {
	unregisterSource(props.id);
});

// Watch for prop changes and update source
watch(
	() => getSourceConfig(),
	(newConfig) => {
		if (map.value?.getSource(props.id)) {
			// MapLibre doesn't support updating sources directly
			// You'd need to remove and re-add, or handle specific updates
			unregisterSource(props.id);
			registerSource(props.id, newConfig);
		}
	},
	{ deep: true },
);
</script>
